import React, { useRef, useEffect, useState } from "react";
import "./dashboard.css";
import { CircularProgress } from "@material-ui/core";
import DashboardTaskbar from "../DashboardTaskbar/DasboardTaskbar";
// import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import RecentFileTab from "../RecentFileTab/RecentFileTab";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
// import Axios from "../../../../../config/Axios";
// import { Statecontext } from "../../../../../context/DataProvider";
/*Use Effect pehle se hi comment me tha */
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecentFiles, fetchAllFiles } from '../../../../../actions/projectActions';
import DasboardTaskbarAdBody from "../DashboardTaskbarBody/DasboardTaskbarAdBody";
import DasboardTaskbarBlogsBody from "../DashboardTaskbarBody/DashboardTaskbarBlogsBody";
import DasboardTaskbarBrainBody from "../DashboardTaskbarBody/DasboardTaskbarBrainBody";
import DasboardTaskbarBrandingBody from "../DashboardTaskbarBody/DasboardTaskbarBrandingBody";
import DasboardTaskbarOthersBody from "../DashboardTaskbarBody/DasboardTaskbarOtherBody";

function Dashboard() {
  const ref = useRef();
  const dispatch = useDispatch();
  // const state = useContext(Statecontext)[0];
  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const [currentTab, setCurrentTab] = useState("ads");

  const [errorMessage, setErrorMessage] = useState("");

  const currentWorkSpace = useSelector(state => state.currentWorkSpace);
  const { currentWorkspaceDetails } = currentWorkSpace;

  const allRecentFiles = useSelector(state => state.allRecentFiles);
  const { loading: loadingRecent, error: errorRecent, fileDetails } = allRecentFiles;

  const allFiles = useSelector(state => state.allFiles);
  const { loading, error, allFileDetails } = allFiles;

  const fileDelete = useSelector(state => state.fileDelete);
  const { afterDelete } = fileDelete;

  const fileRename = useSelector(state => state.fileRename);
  const { renameFileInfo } = fileRename;

  const fileDuplicate = useSelector(state => state.fileDuplicate);
  const { duplicateFileInfo } = fileDuplicate;

  const fileMove = useSelector(state => state.fileMove);
  const { moveFileInfo } = fileMove;

  useEffect(() => {
    if (currentWorkspaceDetails) {
      setErrorMessage("");
      dispatch(fetchRecentFiles(currentWorkspaceDetails._id));
      dispatch(fetchAllFiles(currentWorkspaceDetails._id));
    } else {
      setErrorMessage("No workspace selected.")
    }
  }, [currentWorkspaceDetails, dispatch, afterDelete, renameFileInfo, duplicateFileInfo, moveFileInfo]);

  // useEffect(
  //   () =>
  //     async function fetchData() {
  //       await Axios.get("/user/workspaces", {
  //         headers: {
  //           Authorization: "Bearer" + " " + state.token,
  //         },
  //       })
  //         .then(function (response) {
  //           alert(response);
  //         })
  //         .catch(function (error) {
  //           alert(error);
  //         });
  //     }, 
  //   []
  // );
  return (
    <div className="dashboard">
      <DashboardTaskbar setCurrentTab={setCurrentTab} />
      {currentTab === 'ads' && <DasboardTaskbarAdBody />}
      {currentTab === 'blogs' && <DasboardTaskbarBlogsBody />}
      {currentTab === 'brainstorming' && <DasboardTaskbarBrainBody />}
      {currentTab === 'branding' && <DasboardTaskbarBrandingBody />}
      {currentTab === 'other' && <DasboardTaskbarOthersBody />}
      <h3 className="recent">Recent Files</h3>
      <div className="recentfiles">
        <div className="recentfiles_container" ref={ref} style={{ color: 'gray' }}>
          {(loading || loadingRecent) ? <CircularProgress /> : (error || errorRecent || errorMessage) ? <h4>{error || errorRecent || errorMessage}</h4> :
            ((fileDetails?.length === 0 && allFileDetails?.length === 0) || (allFileDetails?.length === 0 && fileDetails?.length === 0)) ? <h4>No recent files</h4> : (
              fileDetails?.map(item => (
                <RecentFileTab key={item._id} name={item.name} fileData={item} />
              ))
            )}
          {allFileDetails?.map(item => (
            <RecentFileTab key={item._id} name={item.name} fileData={item} />
          ))}
        </div>
        {(fileDetails || allFileDetails) && (allFileDetails?.length !== 0 || fileDetails?.length !== 0) && (
          <div
            onClick={(e) => {
              e.preventDefault();
              scroll(100);
            }}
            className="recentfiles__slider"
          >
            <ArrowForwardIosIcon fontSize="large" />
          </div>
        )}

      </div>
    </div>
  );
}

export default Dashboard;
